const DOCUMENT_RECIPIENT_COPY_TAG_SCOPE = 'document-recipient-copy-tag';

export const DocumentRecipientCopyTagTestIds = {
  getTagId: documentId => `${DOCUMENT_RECIPIENT_COPY_TAG_SCOPE}.tag-${documentId}`,
};
